module.exports = __webpack_public_path__ + "img/shelf.5cddcd0a.svg";